var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 868,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 868,
    fill: "#c5b6a5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.000000) translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#552a08",
    fillOpacity: 0.501961,
    points: "271,187 123,146 2,232"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "143,-16 46,162 271,80"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0a0000",
    fillOpacity: 0.501961,
    points: "55,106 40,11 105,22"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "91,-16 243,5 146,162"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#201200",
    fillOpacity: 0.501961,
    points: "235,155 191,161 216,232"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#614226",
    fillOpacity: 0.501961,
    points: "53,189 33,232 26,109"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fafffd",
    fillOpacity: 0.501961,
    points: "-16,53 29,-16 18,210"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#320300",
    fillOpacity: 0.501961,
    points: "88,70 30,43 79,10"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6a360c",
    fillOpacity: 0.501961,
    points: "209,231 121,195 97,130"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "206,36 31,5 219,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c78738",
    fillOpacity: 0.501961,
    points: "268,144 271,229 194,220"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c37a46",
    fillOpacity: 0.501961,
    points: "18,142 117,51 65,52"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#918964",
    fillOpacity: 0.501961,
    points: "131,135 256,96 271,133"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c7ae9a",
    fillOpacity: 0.501961,
    points: "61,215 155,210 38,160"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "88,117 226,91 127,-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "128,153 189,159 193,135"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#291300",
    fillOpacity: 0.501961,
    points: "52,13 43,64 107,30"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e4d8c9",
    fillOpacity: 0.501961,
    points: "93,180 15,81 113,114"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bad8e5",
    fillOpacity: 0.501961,
    points: "171,200 197,192 188,159"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "145,122 201,116 216,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e2dac7",
    fillOpacity: 0.501961,
    points: "34,49 -16,4 61,-15"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecf3f3",
    fillOpacity: 0.501961,
    points: "32,225 -16,163 18,119"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a4724f",
    fillOpacity: 0.501961,
    points: "98,214 63,169 175,175"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#18140b",
    fillOpacity: 0.501961,
    points: "241,135 226,189 205,193"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cfd0c2",
    fillOpacity: 0.501961,
    points: "201,98 228,164 206,167"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#382a16",
    fillOpacity: 0.501961,
    points: "138,201 169,217 179,171"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cfc1a6",
    fillOpacity: 0.501961,
    points: "271,101 214,100 216,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9f896f",
    fillOpacity: 0.501961,
    points: "-6,110 51,161 43,111"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fbead3",
    fillOpacity: 0.501961,
    points: "127,198 197,232 88,232"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a7744d",
    fillOpacity: 0.501961,
    points: "15,83 32,85 43,25"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000105",
    fillOpacity: 0.501961,
    points: "192,154 199,180 232,185"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dcd3c7",
    fillOpacity: 0.501961,
    points: "153,160 18,97 154,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e2b47e",
    fillOpacity: 0.501961,
    points: "226,194 249,97 271,188"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "179,120 211,-9 70,-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#430c00",
    fillOpacity: 0.501961,
    points: "107,54 102,29 109,34"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1e6d1",
    fillOpacity: 0.501961,
    points: "57,74 41,59 9,135"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#683e1a",
    fillOpacity: 0.501961,
    points: "110,157 167,163 76,197"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a25e2e",
    fillOpacity: 0.501961,
    points: "84,85 79,41 37,102"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ae7d43",
    fillOpacity: 0.501961,
    points: "247,232 271,187 191,200"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ca956d",
    fillOpacity: 0.501961,
    points: "159,187 122,196 111,169"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#585b5b",
    fillOpacity: 0.501961,
    points: "202,106 240,140 244,127"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8a7057",
    fillOpacity: 0.501961,
    points: "36,210 40,94 20,146"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ac9c8a",
    fillOpacity: 0.501961,
    points: "60,129 99,184 68,192"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#aa9571",
    fillOpacity: 0.501961,
    points: "119,116 165,141 200,132"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f1f7f6",
    fillOpacity: 0.501961,
    points: "25,73 4,-16 -16,92"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#311f07",
    fillOpacity: 0.501961,
    points: "51,68 66,13 95,19"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "201,116 89,102 128,20"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#662c14",
    fillOpacity: 0.501961,
    points: "165,156 185,183 176,156"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c2cac1",
    fillOpacity: 0.501961,
    points: "237,130 207,114 210,167"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#250900",
    fillOpacity: 0.501961,
    points: "118,185 104,188 99,174"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8f8c5f",
    fillOpacity: 0.501961,
    points: "227,103 192,121 214,97"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "188,166 192,135 163,145"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d0c3ae",
    fillOpacity: 0.501961,
    points: "211,0 247,4 264,122"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ddd1c5",
    fillOpacity: 0.501961,
    points: "44,150 57,98 68,208"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5c3213",
    fillOpacity: 0.501961,
    points: "39,59 94,54 94,34"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#daa585",
    fillOpacity: 0.501961,
    points: "104,38 108,81 88,47"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f8fbf9",
    fillOpacity: 0.501961,
    points: "44,-7 239,-16 138,41"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cfc3af",
    fillOpacity: 0.501961,
    points: "115,-14 18,1 21,29"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#886236",
    fillOpacity: 0.501961,
    points: "192,119 170,131 154,125"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b2704c",
    fillOpacity: 0.501961,
    points: "162,161 118,149 181,190"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d7d0c2",
    fillOpacity: 0.501961,
    points: "111,136 137,152 196,123"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#603b14",
    fillOpacity: 0.501961,
    points: "197,228 129,197 159,189"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "213,50 89,88 215,96"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#542c0d",
    fillOpacity: 0.501961,
    points: "110,205 98,232 101,207"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e8eae6",
    fillOpacity: 0.501961,
    points: "-16,127 6,217 21,122"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5e2d00",
    fillOpacity: 0.501961,
    points: "197,197 182,204 169,200"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5e645c",
    fillOpacity: 0.501961,
    points: "189,162 202,191 196,138"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#45280c",
    fillOpacity: 0.501961,
    points: "48,66 73,52 38,38"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eadfd3",
    fillOpacity: 0.501961,
    points: "50,116 101,167 90,84"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#86533d",
    fillOpacity: 0.501961,
    points: "34,61 24,81 35,83"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#301400",
    fillOpacity: 0.501961,
    points: "122,169 114,155 148,171"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0d5b3",
    fillOpacity: 0.501961,
    points: "207,203 187,212 173,205"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00050d",
    fillOpacity: 0.501961,
    points: "170,182 162,183 163,203"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f5f0e6",
    fillOpacity: 0.501961,
    points: "154,160 132,148 195,145"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c5c3b8",
    fillOpacity: 0.501961,
    points: "38,232 -16,198 20,180"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#966748",
    fillOpacity: 0.501961,
    points: "135,153 105,156 112,140"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b8ad9c",
    fillOpacity: 0.501961,
    points: "94,195 99,211 51,202"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a3a6a0",
    fillOpacity: 0.501961,
    points: "190,162 199,194 167,201"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#746351",
    fillOpacity: 0.501961,
    points: "34,183 28,232 70,214"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fffffd",
    fillOpacity: 0.501961,
    points: "207,105 170,122 88,73"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9b5c36",
    fillOpacity: 0.501961,
    points: "52,77 101,68 58,58"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dad0bd",
    fillOpacity: 0.501961,
    points: "129,184 111,178 128,178"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#36210b",
    fillOpacity: 0.501961,
    points: "54,69 46,17 84,14"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#be9871",
    fillOpacity: 0.501961,
    points: "21,58 36,34 45,57"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9a805f",
    fillOpacity: 0.501961,
    points: "239,137 213,170 225,170"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eeece3",
    fillOpacity: 0.501961,
    points: "16,116 48,89 25,86"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d1cbbf",
    fillOpacity: 0.501961,
    points: "143,150 93,105 158,130"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3a2e1c",
    fillOpacity: 0.501961,
    points: "103,193 88,192 97,186"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6c6b38",
    fillOpacity: 0.501961,
    points: "195,130 179,130 177,139"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e0b889",
    fillOpacity: 0.501961,
    points: "271,134 242,123 231,191"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#af9883",
    fillOpacity: 0.501961,
    points: "53,149 35,146 56,211"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a7a679",
    fillOpacity: 0.501961,
    points: "206,98 270,100 246,121"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fcd6c3",
    fillOpacity: 0.501961,
    points: "103,49 92,47 104,33"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ddd6c9",
    fillOpacity: 0.501961,
    points: "232,35 170,33 259,65"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b5b3a6",
    fillOpacity: 0.501961,
    points: "195,157 203,106 211,166"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3a3b35",
    fillOpacity: 0.501961,
    points: "200,198 192,155 215,188"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b58954",
    fillOpacity: 0.501961,
    points: "199,200 271,186 209,232"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#916c40",
    fillOpacity: 0.501961,
    points: "-16,124 -6,113 14,114"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d9cab3",
    fillOpacity: 0.501961,
    points: "46,-16 43,33 23,34"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3a1e00",
    fillOpacity: 0.501961,
    points: "108,45 108,37 102,29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLow);
export default __webpack_public_path__ + "static/media/contact_low.6a08841aba4ffc8bceccf85a3e0f604f.svg";
export { ForwardRef as ReactComponent };